import Response from '../base/Response';

export default class PaymentDeclinedResponse extends Response {

}
